// maintenance.guard.ts (or put it in a guards folder)
import { inject } from '@angular/core';
import { CanMatchFn, Router, Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const maintenanceGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
): Observable<boolean> => {

  const http = inject(HttpClient);
  const router = inject(Router);
  const baseUrl = environment?.apiUrluser;


  return http
    .get<{
      data: { maintenance: boolean; message: string };
      message: string;
    }>(`${baseUrl}/system/maintenance-status`)
    .pipe(
      map(response => {
        return response?.data?.maintenance === true;
      }),
      catchError((error) => {
        console.error('API Error:', error);
        return of(false);
      }),
      shareReplay(1)
    );


};